import { useFrontendApiConfig } from "../FrontendApiConfigProvider";
import type { GqlObj, GqlObjConfig } from "./types";

export function useGraphqlObjConfig(query: GqlObj): GqlObjConfig {
  const contextConfig = useFrontendApiConfig();
  const { config: queryConfig } = query;
  const shouldUseQueryConfig =
    queryConfig && !!queryConfig.endpoint && !!queryConfig.schema;
  if (shouldUseQueryConfig) {
    return queryConfig;
  } else {
    if (!contextConfig) {
      throw new TypeError(
        "Calling useGraphqlObjConfig requires to be wrapped by FrontendApiConfigProvider or config on the queryObj",
      );
    }
    return {
      endpoint: contextConfig.graphQLEndpoint,
      schema: contextConfig.schema,
      namespace: contextConfig.namespace,
    };
  }
}
